<script setup>
import { onMounted, ref } from 'vue'

const titrePrincipal = ref(null)

onMounted(() => {
  document.title = 'Merci pour votre commande - Lulu en bus'

  if(titrePrincipal.value) {
    titrePrincipal.value.focus()
  }
})
</script>

<template>
  <div class="text-center container">
    <h1 class="my-3 my-sm-5" ref="titrePrincipal" tabindex="-1">
      Merci pour votre commande
    </h1>

    <p>
      Le réseau Lulu en bus est heureux de vous compter parmi nos nouveaux abonnés et
      nous vous remercions pour votre commande.
    </p>
    <p>Bonne route à bord !</p>

    <address class="coordonnees">
      <strong>Agence de Mobilité Lulu en bus</strong><br />
      3 Pl. Pierre Semard<br />
      54300 Lunéville<br />
      Téléphone : <a href="tel:0800607062">0 800 607 062</a><br />
      Formulaire :
      <a
        href="https://lulu-mobilite.fr/contact/"
        aria-label="Accéder au formulaire de contact de l'agence Lulu en bus"
      >
        Contactez-nous
      </a>
    </address>

    <a class="bouton_valid btn btn-lg" href="https://lulu-mobilite.fr">
      Retour à l'accueil du site Lulu en bus
    </a>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/main';

.coordonnees {
  margin: 2rem 0;
  font-style: normal;
}

.bouton_valid {
  display: inline-block;
  margin: 2rem auto;
  @include boutons;

  &:hover {
    @include boutons_hover;
  }

  &:focus-visible {
    @include boutons_hover;
    outline: 3px solid #000;
    outline-offset: 2px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
}
</style>
